import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type BackgroundJobFieldsFragment = { __typename?: 'BackgroundJob', jobId: string, type: Types.BackgroundJobType, title: string, sourceRoute: string, status: Types.BackgroundJobStatus, total: number, done: number, failed: number, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, finishedAt?: Types.TDateISO | null, dismissedAt?: Types.TDateISO | null, resultLink?: string | null, isListedOnly: boolean };

export type GetMyBackgroundJobsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMyBackgroundJobsQuery = { __typename?: 'Query', myBackgroundJobs: Array<{ __typename?: 'BackgroundJob', jobId: string, type: Types.BackgroundJobType, title: string, sourceRoute: string, status: Types.BackgroundJobStatus, total: number, done: number, failed: number, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, finishedAt?: Types.TDateISO | null, dismissedAt?: Types.TDateISO | null, resultLink?: string | null, isListedOnly: boolean }> };

export type GetBackgroundJobQueryVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
}>;


export type GetBackgroundJobQuery = { __typename?: 'Query', backgroundJob?: { __typename?: 'BackgroundJob', jobId: string, type: Types.BackgroundJobType, title: string, sourceRoute: string, status: Types.BackgroundJobStatus, total: number, done: number, failed: number, createdAt: Types.TDateISO, updatedAt: Types.TDateISO, finishedAt?: Types.TDateISO | null, dismissedAt?: Types.TDateISO | null, resultLink?: string | null, isListedOnly: boolean } | null };

export type GetBackgroundJobItemsQueryVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
  state?: Types.InputMaybe<Types.BackgroundJobItemState>;
  skip: Types.Scalars['Int']['input'];
  take: Types.Scalars['Int']['input'];
}>;


export type GetBackgroundJobItemsQuery = { __typename?: 'Query', backgroundJobItems: Array<{ __typename?: 'BackgroundJobItem', itemId: string, label: string, state: Types.BackgroundJobItemState, error?: string | null, resultIds: Array<string>, attempt: number }> };

export const BackgroundJobFieldsFragmentDoc = new TypedDocumentString(`
    fragment BackgroundJobFields on BackgroundJob {
  jobId
  type
  title
  sourceRoute
  status
  total
  done
  failed
  createdAt
  updatedAt
  finishedAt
  dismissedAt
  resultLink
  isListedOnly
}
    `, {"fragmentName":"BackgroundJobFields"});
export const GetMyBackgroundJobsDocument = new TypedDocumentString(`
    query GetMyBackgroundJobs {
  myBackgroundJobs {
    ...BackgroundJobFields
  }
}
    fragment BackgroundJobFields on BackgroundJob {
  jobId
  type
  title
  sourceRoute
  status
  total
  done
  failed
  createdAt
  updatedAt
  finishedAt
  dismissedAt
  resultLink
  isListedOnly
}`);
export const GetBackgroundJobDocument = new TypedDocumentString(`
    query GetBackgroundJob($jobId: String!) {
  backgroundJob(jobId: $jobId) {
    ...BackgroundJobFields
  }
}
    fragment BackgroundJobFields on BackgroundJob {
  jobId
  type
  title
  sourceRoute
  status
  total
  done
  failed
  createdAt
  updatedAt
  finishedAt
  dismissedAt
  resultLink
  isListedOnly
}`);
export const GetBackgroundJobItemsDocument = new TypedDocumentString(`
    query GetBackgroundJobItems($jobId: String!, $state: BackgroundJobItemState, $skip: Int!, $take: Int!) {
  backgroundJobItems(jobId: $jobId, state: $state, skip: $skip, take: $take) {
    itemId
    label
    state
    error
    resultIds
    attempt
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetMyBackgroundJobs: build.query<GetMyBackgroundJobsQuery, GetMyBackgroundJobsQueryVariables | void>({
      query: (variables) => ({ document: GetMyBackgroundJobsDocument, variables })
    }),
    GetBackgroundJob: build.query<GetBackgroundJobQuery, GetBackgroundJobQueryVariables>({
      query: (variables) => ({ document: GetBackgroundJobDocument, variables })
    }),
    GetBackgroundJobItems: build.query<GetBackgroundJobItemsQuery, GetBackgroundJobItemsQueryVariables>({
      query: (variables) => ({ document: GetBackgroundJobItemsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetMyBackgroundJobsQuery, useLazyGetMyBackgroundJobsQuery, useGetBackgroundJobQuery, useLazyGetBackgroundJobQuery, useGetBackgroundJobItemsQuery, useLazyGetBackgroundJobItemsQuery } = injectedRtkApi;
